<fieldset>
 <legend>
  Initial
 </legend>
 <fieldset>
 <legend>
  conditions
 </legend>
 <app-conditions  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [conditions]="initial.conditions"></app-conditions>
</fieldset>

<!---->

<fieldset>
 <legend>
  criteres
 </legend>
 <app-type-cr-jugement  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [criteres]="initial.criteres"></app-type-cr-jugement>
</fieldset>

<!---->

<fieldset>
 <legend>
  description
 </legend>
 <!-- <app-description  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [description]="initial.description"></app-description> -->
</fieldset>

<!---->

<fieldset>
 <legend>
  caracteristiques
 </legend>
 <app-type-caracteristiquesMAPA  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [caracteristiques]="initial.caracteristiques"></app-type-caracteristiquesMAPA>
</fieldset>

<!---->

<fieldset>
 <legend>
  adressesComplt
 </legend>
 <app-type-rensA  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [adressesComplt]="initial.adressesComplt"></app-type-rensA>
</fieldset>

<!---->

<fieldset>
 <legend>
  natureMarche
 </legend>
 <app-type-nature-marche-lot  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [natureMarche]="initial.natureMarche"></app-type-nature-marche-lot>
</fieldset>

<!---->

<fieldset>
 <legend>
  duree
 </legend>
 <app-type-duree-marche  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [typeDureeMarche]="initial.duree"></app-type-duree-marche>
</fieldset>

<!---->

<fieldset>
 <legend>
  infosSup
 </legend>
 <app-infos-sup  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [infosSup]="initial.infosSup"></app-infos-sup>
</fieldset>

<!---->

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="initial.marcheUnique"

[label]="'marcheUnique'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_marcheUnique'">
</app-form-input>

<!---->

<fieldset>
 <legend>
  justifications
 </legend>
 <app-type-justif  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [justifications]="initial.justifications"></app-type-justif>
</fieldset>

<!---->

<fieldset>
 <legend>
  procedure
 </legend>
 <app-procedure  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [procedure]="initial.procedure"></app-procedure>
</fieldset>

<!---->

<fieldset>
 <legend>
  renseignements
 </legend>
 <app-renseignements  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [renseignements]="initial.renseignements"></app-renseignements>
</fieldset>

<!---->

<fieldset>
 <legend>
  lots
 </legend>
 <app-type-lotsMAPA  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [lots]="initial.lots"></app-type-lotsMAPA>
</fieldset>

<!---->

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="initial.delaiUrgence"

[label]="'delaiUrgence'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_delaiUrgence'">
</app-form-input>
</fieldset>
